import { eventActions } from '../../../../store/modules/event';
import { useDispatch } from 'react-redux';
import { EventOption } from '../../../../store/modules/event/type';

const useEventAllListViewModel = (allEvent: any) => {
  const dispatch = useDispatch();

  const getAllList = (data: Partial<EventOption>) => {
    const { filterOption, pagination } = allEvent.allEventList;

    dispatch(
      eventActions.getAllEventList({
        filterOption,
        pagination,
        ...data,
      }),
    );
  };

  const getEventTagColumnTagList = (data: any) => {
    dispatch(eventActions.getEventTagColumnTagList(data));
  };

  return {
    getAllList,
    getEventTagColumnTagList,
  };
};

export default useEventAllListViewModel;
